import React from 'react';

interface SatisfactionItem {
  name: string;
  value: number;
  color: string;
}

interface Props {
  data: SatisfactionItem[];
  isDark?: boolean;
  height?: number; // Tinggi area chart
}

const SatisfactionBarChart: React.FC<Props> = ({ data, isDark, height = 150 }) => {
  const totalResponden = data.reduce((sum, item) => sum + Number(item.value), 0) || 1;
  // Cari nilai tertinggi untuk skala bar
  const maxValue = Math.max(...data.map(d => Number(d.value)), 1);

  return (
    <div style={{ width: '100%', padding: '10px 0' }}>
      {/* Area Bar (Flexbox Row untuk menjejajarkan bar ke samping) */}
      <div style={{ 
        display: 'flex', 
        alignItems: 'flex-end', 
        justifyContent: 'space-around', 
        height: `${height}px`,
        gap: '10px',
        paddingBottom: '10px',
        borderBottom: `1px solid ${isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'}`
      }}>
        {data.map((item, index) => {
          const val = Number(item.value);
          const percentage = (val / maxValue) * 100;

          return (
            <div key={index} style={{ 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center', 
              flex: 1,
              height: '100%' 
            }}>
              {/* Angka di atas bar */}
              <div style={{ 
                fontSize: '10px', 
                fontWeight: '800', 
                color: item.color,
                marginBottom: '4px'
              }}>
                {val}
              </div>

              {/* Bar Vertical */}
              <div style={{ 
                flex: 1, 
                width: '100%', 
                maxWidth: '30px', 
                display: 'flex', 
                alignItems: 'flex-end',
                backgroundColor: isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)',
                borderRadius: '6px 6px 0 0'
              }}>
                <div style={{ 
                  width: '100%', 
                  height: `${percentage}%`, 
                  backgroundColor: item.color, 
                  borderRadius: '4px 4px 0 0',
                  transition: 'height 1s ease-out',
                  boxShadow: `0 -4px 12px ${item.color}33`
                }} />
              </div>
            </div>
          );
        })}
      </div>

      {/* Label Nama (di bawah garis) */}
      <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '10px', gap: '10px' }}>
        {data.map((item, index) => (
          <div key={index} style={{ 
            flex: 1, 
            fontSize: '8px', 
            fontWeight: '700', 
            textAlign: 'center',
            color: isDark ? '#94a3b8' : '#64748b',
            textTransform: 'uppercase',
            lineHeight: '1.2'
          }}>
            {item.name}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SatisfactionBarChart;